import { ApplyForEoriCTA } from "./ctas";
export var ApplyForEoriIA = function ApplyForEoriIA(strictLocalize, articles) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getPrimaryCTA;
        return (_getPrimaryCTA = getPrimaryCTA(context, strictLocalize, articles)) === null || _getPrimaryCTA === void 0 ? void 0 : _getPrimaryCTA.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getPrimaryCTA2, _getPrimaryCTA2$getLi;
        return (_getPrimaryCTA2 = getPrimaryCTA(context, strictLocalize, articles)) === null || _getPrimaryCTA2 === void 0 ? void 0 : (_getPrimaryCTA2$getLi = _getPrimaryCTA2.getLink) === null || _getPrimaryCTA2$getLi === void 0 ? void 0 : _getPrimaryCTA2$getLi.call(_getPrimaryCTA2);
      }
    }
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return APPLY_FOR_EORI(strictLocalize);
    },
    getDescription: function getDescription() {
      return [EORI_DEFINITION(strictLocalize)];
    }
  };
};
var getPrimaryCTA = function getPrimaryCTA(_context, strictLocalize, articles) {
  return ApplyForEoriCTA(strictLocalize, articles);
};
var APPLY_FOR_EORI = function APPLY_FOR_EORI(strictLocalize) {
  return strictLocalize({
    id: "w1hyF6",
    defaultMessage: [{
      "type": 0,
      "value": "Demander un numéro EORI"
    }]
  });
};
var EORI_DEFINITION = function EORI_DEFINITION(strictLocalize) {
  return strictLocalize({
    id: "elnXE+",
    defaultMessage: [{
      "type": 0,
      "value": "Un numéro EORI permet d'éviter les retards potentiels et les frais de stockage si votre commande ne peut pas être traitée par les douanes dans les délais impartis. Nous vous recommandons donc d'obtenir un numéro EORI si vous importez des marchandises d'un autre pays. Vous trouverez ci-dessous les liens spécifiques à chaque pays pour demander un numéro EORI."
    }]
  });
};